import React from 'react'

import { compose, withHandlers, withProps } from 'recompose'
import styled from 'styled-components'

import LaterLogo from 'assets/images/later-logo.png'
import Button from 'components/Button'
import withHeroText, { HeroTextProps } from 'components/HOCs/withHeroText'
import withRemoteStrings, { RemoteStringsProps } from 'components/HOCs/withRemoteStrings'
import Layout from 'components/Layout'
import Nav from 'components/Nav'
import Separator from 'components/Separator'
import { withClickTrack } from 'components/Trackers/ClickTracker'
import { TRACKER_IDS } from 'components/Trackers/trackerIDs'
import { Title } from 'components/Typography'
import { style } from 'theme'
import { FlowRoute } from 'utils/FlowProvider/types'

import { TestIDs } from '../../../../test/utils/testIds'

type Props = {
  handleClick: () => void
  header: string
  text: string
} & HeroTextProps &
  RemoteStringsProps

export const enhance = compose<Props, {}>(
  withHeroText,
  withRemoteStrings,
  withProps(({ getRemoteString, heroText }) => {
    return {
      header: getRemoteString('welcome_header_v1', heroText.header),
      text: getRemoteString('welcome_text_v1', heroText.text),
    }
  }),
  withHandlers({
    handleClick: ({ route }) => () => {
      route({ from: FlowRoute.Welcome, action: 'continue' })
    },
  }),
)

const GetStartedButton = withClickTrack<any, any>(TRACKER_IDS.WELCOME.NEXT_BUTTON)(Button)

const Container = styled.div`
  text-align: center;
`

const Logo = styled.object`
  margin: 30px auto;
  max-width: 360px;
  width: 100%;
`

const FallbackLogo = styled.img`
  margin: 30px auto;
  max-width: 360px;
  width: 100%;
`

const Header = styled(Title)`
  font-size: 22px;
  font-weight: 600;
  line-height: 30px;
  margin: 0 auto 5px;
`

const Text = styled.div`
  color: ${style(theme => theme.colors.slate)};
  letter-spacing: 0px;
  line-height: 22px;
  max-width: 450px;
  margin: 0 auto;
  margin-bottom: 80px;

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    margin-bottom: 60px;
  }
`

export const LaterLanding: React.SFC<Props> = ({ handleClick, header, text, getRemoteString }) => (
  <>
    <Nav />
    <Layout>
      <Container>
        <Logo data={getRemoteString('welcome_image_v1', LaterLogo, true)} type="image/png">
          <FallbackLogo src={LaterLogo} />
        </Logo>
        <Header data-testid={TestIDs.WELCOME.LATER.HEADER}>{header}</Header>
        <Text data-testid={TestIDs.WELCOME.LATER.TEXT}>{text}</Text>
        <Separator />
        <GetStartedButton onPress={handleClick} data-testid={TestIDs.WELCOME.LATER.SUBMIT_CTA}>
          {getRemoteString('welcome_cta_v1', 'Get started')}
        </GetStartedButton>
      </Container>
    </Layout>
  </>
)

export default enhance(LaterLanding)
